"use client";

import React, { useId } from "react";

/**
 * The ring PO UI's `po-loading-icon` draws (MIT, po-ui/po-angular): one arc
 * fading in, one fading out, spun by CSS. It paints in `currentColor`.
 */
const AniLoadingIcon = ({ className }: { className?: string }) => {
  const id = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      aria-hidden="true"
      className={`ani-loading-icon${className ? ` ${className}` : ""}`}
    >
      <defs>
        <linearGradient id={`${id}-fade-in`}>
          <stop offset="0" stopOpacity="0" stopColor="currentColor" />
          <stop offset="1" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
        <linearGradient id={`${id}-fade-out`}>
          <stop offset="0" stopOpacity="1" stopColor="currentColor" />
          <stop offset="1" stopOpacity="0.5" stopColor="currentColor" />
        </linearGradient>
      </defs>
      <g strokeWidth="24" transform="matrix(0.876218, 0, 0, 0.87855, 12.377892, 12.144993)">
        <path d="M 4 100 A 96 96 0 0 1 196 100" stroke={`url(#${id}-fade-in)`} />
        <path d="M 196 100 A 96 96 0 0 1 4 100" stroke={`url(#${id}-fade-out)`} />
        <path d="M 4 100 A 96 96 0 0 1 4 98" stroke="currentColor" />
      </g>
    </svg>
  );
};

export default AniLoadingIcon;
